import { Flame } from "lucide-react";
import { Card, CardContent, IconChip } from "@/components/ui/card";

// Streaks read as gentle continuity, never a trophy. No "streak lost" guilt;
// the copy stays quiet and forward-looking (Master Build §1, design system).
export function StreakCard({
  days = 0,
  bestStreak,
  checkedInToday = false,
  className,
}: {
  days?: number;
  bestStreak?: number;
  checkedInToday?: boolean;
  className?: string;
}) {
  return (
    <Card className={className}>
      <CardContent className="flex items-center gap-3">
        <IconChip icon={Flame} tint="yellow" />
        <div>
          <div className="text-2xl font-bold leading-tight text-foreground">
            {days} days
          </div>
          <div className="mt-0.5 text-xs text-muted-foreground">
            {checkedInToday
              ? "Today's check-in complete"
              : "Check in to keep your streak"}
            {bestStreak ? ` · Best: ${bestStreak}` : ""}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
